export default __webpack_public_path__ + "static/media/Event5_M2.1d01e20a.gif";